import { useGAEventStore } from '@/store/GAEventTracking'
import type { App } from 'vue'

export default {
  install: (app: App) => {
    const store = useGAEventStore()

    app.directive('ga-swiper-dot', {
      mounted(el, { value }) {
        nextTick(() => {
          // a swiper can legitimately run without built-in pagination (Classic World draws
          // its own), so this has to tolerate the element being absent
          const pagination = el.querySelector('.swiper-pagination')
          if (!pagination) return
          const dots = pagination.childNodes
          dots.forEach((element: any, index: number) => {
            element.addEventListener('click', () => {
              store.pushActionEvent(
                {
                  interaction: 'carousel_click',
                  sectionContent: value ?? `Dot: ${index + 1}`,
                },
                el
              )
            })
          })
        })
      },
    })
  },
}
